import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import CustomButton from "../../../components/AddButton";
import { useLiveTracking } from "../../../hooks/useLiveTracking";
// OLD MAP COMPONENT - COMMENTED OUT
// import SimpleLiveTrackingMap from "../../../components/LiveTracking/LiveTrackingMap";
// NEW MAP COMPONENT - SIMPLIFIED VERSION
import SimpleTripMap from "../../../components/TripMap/SimpleTripMap";
import { ApiService } from "../../../service/api.service";
import { OPERTIONS_URL, MASTER_URL } from "../../../common/common";

import {
  coin,
  Plus,
  map,
  edit,
  fuel,
  vehicle,
  container,
  toll,
  police,
  driver,
  others,
  trips,
  speed,
  milage,
  vehiclecontainer, vehicledriver, vehicleTruck
} from "../../../common/svg";
import CustomChip from "../../../components/Chip";
import PhotoGrid from "../../../components/ImageView";
import DocumentUpload from "./components/Upload";
import Filter from "../../../components/FilterButton";
import Notification from "../../Notification";
import ReportButton from "../../../components/ReportButton";
import DateTimePicker from "../../../components/Date&Time";
import { images } from "../../../common/tabs";
import DeliveryTimeline from "../../../components/DeliveryTimeline";
import Details from "../details";
import SecureImage from "../../../components/BucketImage/Image";
import { useParams } from "react-router-dom";
import AssignVehicle from "../../../containers/Forms/Vehicles/master/Assignvehicle";
import Assignsurveyor from "../../../containers/Forms/Surveyor/masterform/Assign Surveyor";
import AssignDriver from "../../../containers/Forms/Driver/MasterForm/AssignDriver";
import AssignContainer from "../../../containers/Forms/ContainerForm/AssignContainer/AssignContainer";
const Trip = () => {
  const { id } = useParams();
  const apiService = new ApiService();
  const [isSurveyorModalOpen, setIsSurveyorModalOpen] = useState(false);
  const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false);
  const [isDriverModalOpen, setIsDriverModalOpen] = useState(false);
  const [isContainerOpen, setIsContainerOpen] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState<any>([]);

  // NEW STATE FOR TRACKING URL AND VEHICLE DATA
  const [trackingUrl, setTrackingUrl] = useState<string | undefined>(undefined);
  const [vehicleData, setVehicleData] = useState<any>(null);

  // MAP DISPLAY STATE - SAME AS TRIPS PAGE
  const [isBlurred, setIsBlurred] = useState(true);

  const {
    showMap,
    hasTrackingData,
    isLoading,
    error,
    startTracking,
    setFirstDataReceived,
    canShowMap,
    isInLoadingState
  } = useLiveTracking();
  const handleClick = () => {
    console.log("Button clicked!");
  };


  useEffect(() => {
    const fetchTripDetails = async () => {
      try {
        const response: any = await apiService.getApi(`${OPERTIONS_URL}/trip/details-route?tripId=${id}`);
        if (response?.status === "200") {
          const tripDetails = response.body[0] || {};
          const vehicleAssignments = tripDetails.vehicleAssignments || [];
          setVehicleDetails(vehicleAssignments);

          // NEW: Fetch vehicle details with tracking URL from master data service
          if (vehicleAssignments.length > 0) {
            const vehicleId = vehicleAssignments[0]?.vehicleId;
            if (vehicleId) {
              console.log("🔍 Fetching vehicle details for vehicleId:", vehicleId);
              try {
                console.log("🔍 Making API call to:", `${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
                const vehicleResponse: any = await apiService.getApi(`${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
                console.log("🔍 Vehicle API response:", vehicleResponse);
                console.log("🔍 Vehicle API response status:", vehicleResponse?.status);
                console.log("🔍 Vehicle API response type:", typeof vehicleResponse?.status);

                if (vehicleResponse?.status === 200 || vehicleResponse?.status === "200") {
                  console.log("🔍 Inside status 200 condition");
                  console.log("🔍 Vehicle response body:", vehicleResponse.body);
                  const vehicleTrackingUrl = vehicleResponse.body?.trackingUrl;
                  console.log("🔍 Vehicle trackingUrl:", vehicleTrackingUrl);
                  console.log("🔍 Vehicle trackingUrl type:", typeof vehicleTrackingUrl);
                  setTrackingUrl(vehicleTrackingUrl);
                  setVehicleData(vehicleResponse.body);
                } else {
                  console.log("🔍 Vehicle API response status is not 200:", vehicleResponse?.status);
                }
              } catch (vehicleError) {
                console.error("❌ Error fetching vehicle details:", vehicleError);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error fetching trip details:", error);
      }
    };

    if (id) {
      fetchTripDetails();
    }
  }, [id]);

  const ShowMap = async () => {
    try {
      console.log("🗺️ Showing map with SimpleTripMap component");
      setIsBlurred(false);

      // Try to start tracking if we have vehicle registration number, but don't block map display
      const vehicleRegNo = vehicleDetails?.[0]?.vechicleData?.vehicleRegNo;
      if (vehicleRegNo) {
        console.log("🚗 Starting tracking for vehicle:", vehicleRegNo);
        await startTracking(vehicleRegNo);
      } else {
        console.log("⚠️ No vehicle registration number found, but showing map anyway");
      }
    } catch (error) {
      console.error("❌ Error starting live tracking:", error);
      // Still show the map even if tracking fails
      setIsBlurred(false);
    }
  };

  const ExpenseDetails = [
    {
      label: "Fuel Expenses",
      amount: "₹ 200",
      icon: fuel,
    },
    {
      label: "Toll Expenses",
      amount: "₹ 200",
      icon: toll,
    },
    {
      label: "RTO Expenses",
      amount: "₹ 200",
      icon: police,
    },
    {
      label: "Driver Expenses",
      amount: "₹ 200",
      icon: driver,
    },
    {
      label: "Other Expenses",
      amount: "₹ 200",
      icon: others,
    },
    {
      label: "Total Expenses",
      amount: "₹ 200",
      icon: coin,
    },
  ];
  return (
    <div>
      <div className="mt-1">{/* < Details/> */}</div>
      <div className=" p-2">
        <div className="flex justify-between bg-[#FFFFFF] border-b border-[#C1C1C1] border-dashed">
          {/* Container Details Section */}
          <div className="flex flex-col py-2 border-r border-[#C1C1C1] border-dashed mr-[20px] px-4 w-1/2">
            <div className="flex items-center justify-between mb-4">
              <div className="flex gap-2 items-center">
                <p className="text-[#444FBD] text-[16px] font-[600] whitespace-nowrap">
                  Container Details
                </p>
                <CustomChip
                  text="Verified"
                  backgroundColor="#ECFFEB"
                  textColor="#04D900"
                  borderColor="#04D900"
                />
              </div>
              <CustomButton label="" onClick={handleClick} icon={edit} />
            </div>
            <Assignsurveyor
              isOpen={isSurveyorModalOpen}
              onClose={() => setIsSurveyorModalOpen(false)}
              tripID={id || ""}
              bookingID={""}
            />
            <AssignContainer open={isContainerOpen} setOpen={setIsContainerOpen} />
            <div className="flex gap-4 h-[70px]">
              {/* <img src={container} alt="Container" className="w-[138.66px]" /> */}
              <SecureImage
                fileKey={container}
                alt="header icon"
                width="138.66px"
              />
              <div className="flex flex-col gap-4 mt-2 ml-20">
                <CustomButton
                  icon={vehicledriver}
                  label="Assign Surveyor"
                  buttonClassName="w-[190px] rounded-[100px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
                  labelClassName="!text-[#7E7E7E]"
                  onClick={() => setIsSurveyorModalOpen(true)}
                />
                <CustomButton
                  icon={vehiclecontainer}
                  label="Assign Container"
                  buttonClassName="w-[190px] rounded-[50px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
                  labelClassName="!text-[#7E7E7E]"
                  onClick={() => setIsContainerOpen(true)}
                />
              </div>
            </div>

          </div>

          {/* Vehicle Details Section */}
          <div className="flex flex-col py-2 mr-[80px] ">
            <div className="flex items-center justify-between mb-4 ">
              <div className="flex gap-2 items-center">
                <p className="text-[#444FBD] text-[16px] font-[600] leading-[27px]">
                  Vehicle Details
                </p>
                <CustomChip
                  text="Verified"
                  backgroundColor="#ECFFEB"
                  textColor="#04D900"
                  borderColor="#04D900"
                />
              </div>
            </div>

            <div className="flex gap-8 h-[80px] ">
              <SecureImage
                fileKey={vehicle}
                alt="header icon"
                width="138.66px"
              />
              <AssignDriver
                isOpen={isDriverModalOpen}
                onClose={() => setIsDriverModalOpen(false)}
                tripID={id || ""}
                bookingID={""}
              />
              <AssignVehicle
                isOpen={isVehicleModalOpen}
                onClose={() => setIsVehicleModalOpen(false)}
                tripID={id || ""}
                bookingID={""}
              />
              <div className="flex flex-col gap-4 mt-2">
                <CustomButton
                  icon={vehicleTruck}
                  label="Assign Vehicle"
                  buttonClassName="w-[190px] rounded-[100px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
                  labelClassName="!text-[#7E7E7E]"
                  onClick={() => setIsVehicleModalOpen(true)}
                />
                <CustomButton
                  icon={vehicledriver}
                  label="Assign Driver"
                  buttonClassName="w-[190px] rounded-[50px] bg-[#F4F4F4] h-[26px] border border-[#767575] whitespace-nowrap"
                  labelClassName="!text-[#7E7E7E]"
                  onClick={() => setIsDriverModalOpen(true)}
                />
              </div>
            </div>


          </div>

          <div className="flex flex-col py-2">
            <div className="flex items-center justify-between mb-4">
              {/* Header or Title Section */}
              <div className="flex gap-2 ml-[350px]">
                <CustomButton label="" icon={edit} onClick={handleClick} />
                <CustomButton label="" icon={Plus} onClick={handleClick} />
              </div>
            </div>

            {/* Distance, Avg Speed, Fuel Consumption, Avg Mileage Section */}
            <div className="grid grid-cols-2 mr-5  ">
              <div className="flex items-center justify-between p-4 gap-2 ml-[60px] bg-[#FFFFFF] border border-[#EAEAEA]  rounded-[20px]  mt-10 w-[175px] h-[70px]">
                <div className="flex items-center gap-2">
                  <SecureImage
                    fileKey={trips}
                    alt="header icon"
                    width="30px"
                  />
                  <div>
                    <p className="text-[#282828] text-[12px] font-poppins font-[400px]">
                      Distance
                    </p>
                    <p className="text-[#282828] text-[18px] font-poppins font-[600px]">
                      1464 Kms
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-[#FFFFFF] gap-5 border border-[#EAEAEA] rounded-[20px] mr-[100px] ml-10 mt-10  w-[175px] h-[70px]">
                <div className="flex items-center gap-2">
                  <SecureImage
                    fileKey={speed}
                    alt="header icon"
                    width="30px"
                  />

                  <div>
                    <p className="text-[#282828] text-[12px] font-poppins font-[400px]">
                      Avg Speed
                    </p>
                    <p className="text-[#282828] text-[18px] font-poppins font-[600px]">
                      64 Kmph
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 ml-[60px] bg-[#FFFFFF] border border-[#EAEAEA]  rounded-[20px] mt-4  w-[175px] h-[70px]">
                <div className="flex items-center gap-2">
                  <SecureImage
                    fileKey={fuel}
                    alt="header icon"
                    width="30px"
                  />
                  <div>
                    <p className="text-[#282828] text-[12px] font-poppins font-[400px] whitespace-nowrap">
                      Fuel Consumption
                    </p>
                    <p className="text-[#282828] text-[18px] font-poppins font-[600px]">
                      45 L
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 mr-20 bg-[#FFFFFF] border border-[#EAEAEA]  mt-4 ml-10 rounded-[20px]  w-[175px] h-[70px]">
                <div className="flex items-center gap-2">
                  <SecureImage
                    fileKey={milage}
                    alt="header icon"
                    width="30px"
                  />
                  <div>
                    <p className="text-[#282828] text-[12px] font-poppins font-[400px] mr-6">
                      Avg Mileage
                    </p>
                    <p className="text-[#282828] text-[18px] font-poppins font-[600px]">
                      11 Km/L
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-2 flex flex-col gap-4 bg-white border-b border-[#C1C1C1] border-dashed ">
          <div className="flex items-center justify-between bg-white">
            <p className=" bg-white text-[16px] font-[600] leading-[30px]">
              Route Points
            </p>
            <CustomButton label="" icon={edit} onClick={handleClick} />
          </div>
          <div className="flex items-start gap-4">
            <div className="">
              <DeliveryTimeline />
            </div>
            <div className="w-[500px] h-[500px] rounded-[20px] mt-6 ml-10 overflow-hidden relative">
              {/* MAP - UPDATED WITH SAME PATTERN AS TRIPS PAGE */}
              {!isBlurred ? (
                <div className="w-full h-full">
                  {/* NEW MAP COMPONENT - SIMPLIFIED VERSION */}
                  <SimpleTripMap
                    tripId={id}
                    showMap={true}
                    onMapReady={() => console.log("🗺️ Trip map is ready")}
                    trackingUrl={trackingUrl}
                  />
                </div>
              ) : (
                <div
                  className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-500 text-3xl font-semibold cursor-pointer"
                  onClick={ShowMap}
                >
                  Show Map
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center justify-between p-2 w-full mt-4">
            <div className="border border-gray-300 shadow rounded-lg px-4 py-2 w-[1943px] h-[40px] mr-[230px]">
              <p className="text-black text-sm font-semibold">
                <span className="font-bold">Route 2</span> –{" "}
                <span className="font-bold">EN14245</span> –{" "}
                <span className="font-medium">Chennai Manali Yard</span> –{" "}
                <span className="font-medium">Ennore Port</span>
              </p>
            </div>
          </div>
        </div>
        <div className="p-2 border-b border-[#C1C1C1] border-dashed  bg-white">
          <div className="flex justify-between items-center  bg-white">
            <p className=" text-[16px] font-[600] text-[#282828] leading-[30px]">
              Expense Details
            </p>
            <div className="flex gap-2">
              <CustomButton label="" icon={edit} onClick={handleClick} />
              <CustomButton label="" icon={Plus} onClick={handleClick} />
            </div>
          </div>
          <div className="grid grid-cols-6 mt-1">
            {ExpenseDetails.map((expense, index) => (
              <div
                key={index}
                className="flex justify-between items-center p-2"
              >
                <div className="flex items-center gap-2">
                  <SecureImage
                    fileKey={expense.icon}
                    alt="header icon"
                    width="30px"
                  />
                  <div>
                    <p
                      className={`text-[14px] ${expense.label === "Total Expenses"
                        ? " text-[16px] font-[600]"
                        : ""
                        }`}
                    >
                      {expense.label}
                    </p>
                    <p
                      className={`text-[14px] ${expense.label === "Total Expenses"
                        ? " text-[16px] font-[600]"
                        : ""
                        }`}
                    >
                      {expense.amount}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <DocumentUpload />
        </div>
      </div>
    </div>
  );
};

export default Trip;
